import React from 'react';
import { connect } from 'react-redux';
import { defineMessages, FormattedMessage } from 'react-intl';
import Global from '../../../../store/global-selectors';
import { ActionableFilterPill } from '../../index';

import { messages as countryNameMessages } from '../../../../components/country-names.messages';

const messages = defineMessages({
  defaultCountryText: {
    description: 'filterOptions.country',
    defaultMessage: 'Country',
    id: 'u24cHM',
  },
});

const getDisplayName = (appliedFilters, countries) => {
  if (appliedFilters.length === 0) {
    return <FormattedMessage defaultMessage='Country' description='filterOptions.country' id='u24cHM' />;
  }
  if (appliedFilters.length > 1) {
    return <FormattedMessage defaultMessage='(Multiple Countries)' description='filterOptions.multipleCountries' id='D43LW6' />;
  }
  const [filter] = appliedFilters;
  const matchingCountry = countries.find((country) => country.code === filter.criterionArgumentValue);
  const countryMessage = countryNameMessages[matchingCountry?.code] || messages.defaultCountryText;

  return <FormattedMessage {...countryMessage} />;
};

const mapStateToProps = (state, ownProps) => {
  const countries = Global.selectReferenceDatagetCountries(state);
  const appliedFilters = Global.selectShipmentsFilteringActiveFilterViewFiltersById(state, {
    filterById: ownProps.filterById,
  });

  return {
    isSelected: !!appliedFilters.length,
    displayContent: getDisplayName(appliedFilters, countries),
  };
};

export const Country = connect(mapStateToProps, null, null, { forwardRef: true })(ActionableFilterPill);
